import React, { Component } from "react";
// import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

import ContentArea from "./components/ContentArea";
import { LeftSidebar, RightSidebar } from "./components/SidebarArea";
import DashboardArea from "./components/DashboardArea";
import FormArea from "./components/FormArea";
import FileFolder from "./components/fileFolder"
import NavbarArea from "./components/NavbarArea";
import ReportArea from "./components/ReportArea";
import { remoteip } from "./config";

import FilterArea from "./components/PushkarFilter/FilterArea";
import Login from "./components/common/auth/Login";
import WebSearch from "./components/common/WebSearch";

import Register from "./components/common/auth/Register"
import { LeftSidebarMore } from "./components/SidebarArea/LeftSidebar";
import ControlSearch from "./components/ControlSearch";


// import { MdError,MdErrorOutline } from "react-icons/md";

// import Ecommerce from "./components/Ecommerce";
// import db from "../../imports/api/definitions/db";
import db from "./pages";

// import { Permanent, Errors } from "../../imports/api/permanent";
import "./styles/main.css";
import "./styles/bootstrap.min.css";
import "./styles/sidebar.css"
import "./styles/custom.css"
import "./styles/checkboxCustom.css"
import "./styles/content.css";
import "./styles/form-section.css";
import "./styles/header.css"
import "./styles/index.css";
import "./styles/select.css";
import "./styles/report.css";
import "./styles/react-table.css"
import "./styles/App.css"
import "./styles/animate.css"
import "./styles/report2.css"
import "./styles/custom2.css"
import "./styles/select2.css";
import "./styles/index2.css";
import "./styles/App2.css"
import "./styles/editor.css"
import "./styles/login.css";
import "./styles/filter.css";
import "./styles/pagename.css";


import {
  shouldDisplayComponent, setCookie, getCookie,
  socket,
  handleLogout
} from "./components/oro-module/commonFunctions";
import { showFileFolder, handleSearch } from "./components/oro-module/ajaxdata";
import { ProfileMenu, TopRightMenus, BusinessControls, GeneralControls, ChartControls } from "./pages/Framework/";
import { openRecord } from "./components/ReportArea/HistoricalData";
import { checkIfFastpathAllowed } from "./pages/commonFunctions";

// on componentdidmount, if logged in, send token and username to authorize the socket id.
const Unsupported = () => {
  return (
    <div>
      Browser is not supported.

    </div>
  )
}


const LogoutWarning = () => {
  return (
    <div id="logout-warning">

    </div>
  )
}

function isComponentAllowed({ pageData, component, current }) {
  let { shouldRender } = shouldDisplayComponent({ current, pageData, component, allData: current.state });
  return shouldRender;
}

function getNestedPageAndData({ component, pageData }) {
  let newPage, hiddenFieldLabel; let newpageData = {};
  if (component['formmodal'] && component['formmodal'].pagename && component['formmodal'].display != 'filter' && pageData[component['name']]) {
    newPage = component['formmodal'].pagename
    newpageData = pageData[component['name']];
    hiddenFieldLabel = component['label'];
  } else if (component['inputType'] == 'fastpathContainer' && component.display != 'filter') {
    newPage = component.pagename;
    newpageData = pageData;
  }
  return { newPage, newpageData, hiddenFieldLabel };
}

function requiredInTable({ pageData, name, tableHeaders }) {
  let shouldProceed = true;
  let requiredCols = {};
  for (var i in tableHeaders) {
    if (tableHeaders[i].isRequired) {
      requiredCols[tableHeaders[i].field] = tableHeaders[i].label;
    }
  }
  let msg = "";

  // Clean data to remove any blank rows?

  if ((!pageData || !pageData[name]) && Object.keys(requiredCols).length != 0) {
    shouldProceed = false;
  } else if (pageData && pageData[name]) {
    for (var i in pageData[name]) {
      if (shouldProceed) {
        for (var col in requiredCols) {
          if (!pageData[name][i][col]) { shouldProceed = false; }
        }
      }
    }
  }
  return { result: shouldProceed, msg };
}


function isThisFieldMissing({ component, pageData, LocalVars, formElements, fileFolder, current }) {
  let errors = [];
  let { newPage, newpageData, hiddenFieldLabel } = getNestedPageAndData({ component, pageData });
  if (newPage && isComponentAllowed({ pageData, component, current })) {
    let le = checkRequiredFieldsInPage({ currentPage: newPage, pageData: newpageData, LocalVars, formElements, fileFolder, current, component }).errors;
    if (hiddenFieldLabel) {
      errors = le.map(err => { err.msg = hiddenFieldLabel; return err; })
    } else {
      errors = le;
    }
  } else if (!newPage) {
    if (component.inputType == 'table') {
      if (component.isRequired) {
        if (!pageData[component.name] || pageData[component.name] == "" || pageData[component.name].length == 0) {
          errors.push({ val: component.name, label: component.label });
        }
      }
      let res = requiredInTable({ pageData, name: component.name, tableHeaders: component.tableHeaders });
      if (!res.result) {
        errors.push({ val: component.name, label: component.label });
      }
    }
    else if (component['name'] && component["isRequired"] == true && isComponentAllowed({ pageData, component, current }) && (!pageData || (pageData && (pageData[component['name']] == undefined || pageData[component['name']] == "")))) {
      errors.push({ val: component['name'] });
    }
  }
  return errors;
}


function getMissingRequiredFields({ component, pageData, LocalVars, formElements, fileFolder, current }) {
  // Check for missing fields in PLAIN component or a SINGLE level modal PAGE. NOT in subcomponents. NOT for MULTI level nested modal pages.

  let errors = [];
  if (component['subComponents']) {
    let formc;
    if (component['subComponents'].fields) {
      formc = component['subComponents'].fields;
    } else {
      formc = component['subComponents'];
    }
    formc.map(subformdef => {
      errors = errors.concat(getMissingRequiredFields({ component: subformdef, pageData, LocalVars, formElements, fileFolder, current }));
    });
  } else {
    errors = errors.concat(isThisFieldMissing({ component, pageData, LocalVars, formElements, fileFolder, current }));
  }
  return errors;
}

function checkRequiredFieldsInPage({ currentPage, pageData, LocalVars, formElements, fileFolder, current, openmodals, component = {} }) {
  // Check if all the required fields are filled on currentPage
  let formDefinition = [];
  // console.log({currentPage,cp:current.state.currentPage});
  if (currentPage == current.state.currentPage) {
    if (LocalVars.showFilter && !fileFolder.isOpen) {
      formDefinition = formElements[currentPage]["filter"];
    } else if (formElements[currentPage] && formElements[currentPage]["form"]) {
      formDefinition = formElements[currentPage]["form"];
    }
  } else {
    if (component['formmodal'].display == 'filter' && !fileFolder.isOpen) {
      formDefinition = formElements[currentPage]["filter"];
    } else {
      formDefinition = formElements[currentPage]["form"];
    }
  }

  let errors = [];
  formDefinition.map(formdef => {
    errors = errors.concat(getMissingRequiredFields({ component: formdef, pageData, LocalVars, formElements, fileFolder, current }));

  });
  return { errors };
}


class App extends Component {
  constructor(props) {
    super(props);
    this.liftState = this.liftState.bind(this);
    this.liftGlobalState = this.liftGlobalState.bind(this);
    // need to refactor it so that useless/local states are not sent to the server.

    let prof = this.props.parentState.profile;
    //console.log("REMOTE IP")
    this.state = {
      remoteip,
      currentPage: this.props.parentState.currentPage,
      session_date: (this.props.parentState && this.props.parentState.session_date) ? this.props.parentState.session_date : "",
      showSidebar: (this.props.parentState && this.props.parentState.identi) ? false : true,
      directloading: false,
      ShowNavbar: true,
      rightSidebarOpen: false,
      businessControlOpen: false,
      pageData: { currency_convert: 'Rupees' },
      controlsData: {},
      allPageData: {},
      screen: { height: window.screen.height, width: window.screen.width },
      leftSidebarLevel: 1,
      leftSidebar2Items: [],
      leftSidebar3Items: [],
      globalFormActions: {},
      showButtons: { submit: false, search: true, edit: false },
      isSpinnerShow: false,
      userLoginData: {},
      formElements: db,
      errorMessages: {},
      unsavedChanges: [],
      alerts: [],
      maxid: {},
      startingPage: 0,
      notifications: {},
      fileFolderError: {},
      OriginalData: [],
      OriginalDataOther: {},
      fileOpenData: {},
      modalProps: false,
      openmodals: [],
      openControls: [],
      opensimplemodals: [],
      fastpathChange: false,
      formheight: 0,
      expandedRows: {},
      totalheight: 0,
      formProgress: [],
      clickedSlice: false,
      clickedSliceLast: false,
      historyTableParams: { perPage: 50, currentPage: 1, limitresults: 200000 },
      fileFolder: {
        pageOrientation: "portrait",
        pageSize: "A4",
        isOpen: false,
        recordID: "",
        selectedTab: "analytics",
        statutoryData: [],
        dataType: ""
      },
      auditorsData: [],
      auditorsSelection: -1,
      formState: "edit",
      workFlowData: {},
      otherPage: "",
      pageHistory: [],
      themecolor: this.props.parentState.themecolor ? this.props.parentState.themecolor : "gmail",
      pageLimits: {},
      tempAutoopenValues: [],
      showProfile: false,
      LocalVars: {
        // showFilter: true,
        sidebarOpenButtonClass: "",
        globalSearch: "",
        activeSidebartabId: "",
        sidebarSearch: "",
        activeTab: {},
        hiddenColumns: {},
        selectedFormTab: "",
        ShowHistory: true,
        compressed: true,
        fullscreenreport: false,
        processedImages: {},
        sessionDate: "",
        subcomponentVisibility: {},
        selectedTourBranch: (prof && prof.visiting_branches && prof.visiting_branches.length > 0) ? { label: prof.visiting_branches[0].branch_display, value: prof.visiting_branches[0].branch_uid, code: prof.visiting_branches[0].branch_code, more_1: prof.visiting_branches[0].more_1, more_2: prof.visiting_branches[0].more_2 } : ""
      },
      full_report: false
    };
  }

  getRequiredField = () => {
    // let lgs = this.props.liftGlobalState;
    let {
      currentPage,
      pageData,
      LocalVars,
      formElements, fileFolder, openmodals
    } = this.state;

    currentPage = currentPage.toLowerCase();
    let current = this;
    let { errors } = checkRequiredFieldsInPage({ currentPage, pageData, LocalVars, formElements, fileFolder, openmodals, current });




    // set errors in state.
    this.setState({ formProgress: errors });
    // console.log({ errors })
    // if (errors.length == 0) {
    if (true) {
      // show submit/search button. 
      let buttontype = { submit: true, search: true, edit: true }
      this.setState({ showButtons: buttontype });
    } else {
      let buttontype = { submit: false, search: false, edit: false }
      this.setState({ showButtons: buttontype });
    }
    // }

  }

  liftState(componentInfo, stateValue) {
    // Check last open modal. get its name and set state as pageData[modalname][componentInfo.name]=stateValue ????

    // Comment below 3 lines to disable form cleaning.
    // Or better yet, make it parameterized.
    const pageName = this.state.currentPage;


    var { pageData, openControls, formState } = this.state;
    setCookie("formState", formState, 1);
    // If pageData[modalname] doesnt exist, create that key.
    // console.log({componentInfo})
    // console.log({stateValue})

    if (componentInfo instanceof Array) {
      for (var i = 0; i < componentInfo.length; i++) {
        if (openControls.length > 0) {
          try {
            openControls[openControls.length - 1]['values'][componentInfo[i].name] = stateValue[i];
          }
          catch (e) {
            openControls[openControls.length - 1]['values'] = { [componentInfo[i].name]: stateValue[i] };
          }
        } else {
          pageData[componentInfo[i].name] = stateValue[i];
        }

        if (openControls.length > 0) {
          this.setState({ openControls });
        } else {
          this.setState({ pageData });
        }
      }
    } else {
      if (openControls.length > 0) {
        try {
          openControls[openControls.length - 1]['values'][componentInfo.name] = stateValue;
        }
        catch (e) {
          openControls[openControls.length - 1]['values'] = { [componentInfo.name]: stateValue };
        }
        this.setState({ openControls });
      } else {
        pageData[componentInfo.name] = stateValue;
        this.setState({ pageData });
      }
    }



    let current = this;
    setTimeout(function () {
      current.getRequiredField();
    }, 10);
  }

  liftGlobalState(componentInfo, stateValue) {
    // Check for openControls
    this.setState({ [componentInfo.name]: stateValue });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let hasFilter = db[prevState.currentPage] ? db[prevState.currentPage].filter : false;


    if (db[prevState.currentPage] && db[prevState.currentPage].defaultPage
    ) {
      hasFilter = false;
    }
    const { LocalVars } = prevState;
    const localvars = { ...LocalVars };

    if (!hasFilter) {
      // LocalVars["showFilter"] = false;
      delete localvars.showFilter;
      // delete localvars.ShowHistory;
      // LocalVars["ShowHistory"] = false;

      prevState.LocalVars = localvars;
      return prevState;
    } else if (hasFilter && localvars.showFilter === undefined) {
      localvars.showFilter = true;
      prevState.LocalVars = localvars;
      return prevState;
    }
    return null;
  }



  async componentDidMount() {
    console.log("MOUNTED ONCE")
    let current = this;
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    navigator.geolocation.getCurrentPosition(function (position) {
      if (position) {
        let { latitude, longitude, accuracy } = position.coords;
        console.log({ latitude, longitude, accuracy })
        setCookie("position", JSON.stringify({ latitude, longitude, accuracy }));
      }
    }, (err) => {
      console.log({
        err
      })
    }, options);


    this.setState({ directloading: true });

    socket.on('connection', function (sock) {
      socket.on('ocrdata', (data) => {
        if (data.filename != 'Hot Folder Log.txt') {
          let { pageData, LocalVars } = current.state;
          if (!data.type) {
            LocalVars['processedImages'][data.filename] = 'fail';
          } else {
            LocalVars['processedImages'][data.filename] = 'success';
          }
          if (data.type == 'pan') {
            if (data.value) {
              pageData['pan'] = data.value;
              current.setState({ pageData });
            }
          } else if (data.type == 'aadhaar') {
            if (data.value) {
              pageData['aadhaar'] = data.value.replace(/ /g, '');
              current.setState({ pageData });
            }
          }
          current.setState({ LocalVars });
        }
      });
    });


    window.addEventListener('storage', function (event) {
      setTimeout(() => {
        let orosession = getCookie("orosession");
        if ((!orosession || orosession == '[]') && ['/login', '/websearch'].indexOf(window.location.pathname) == -1) {
          window.location = "/";
        }
      },
        2000);
    });

    document.addEventListener("keyup", this.doc_keyUp, false);
    let { identi, fileFolder, currentPage, token, user_code } = this.props.parentState;
    // document.getElementById("root").requestFullscreen;
    let elem = document.getElementById("");

    // socket.emit('browserlogin', { token, loginid: user_code });

    // Check if the current path is allowed.

    let p = {
      props: {
        parentState: this.state,
        parentProps: this.props,
        liftGlobalState: this.liftGlobalState,
        liftState: this.liftState,
        liftWrapperState: this.props.liftGlobalState
      }
    }
    let ws = window.location.pathname.split('/');
    if (['login', 'websearch'].indexOf(ws[1]) == -1 && ws[1] != '') {
      let response = await checkIfFastpathAllowed({ searched: currentPage, current: p });
      let { results, exceptions, error, success, proceed, pagename } = response;
      if (!proceed) {
        // window.location = "/dashboard1";
        this.setState({ currentPage: "dashboard1" });
        //eslint-disable-next-line
        history.pushState(null, '', '/dashboard1');
      }
    }

    if (identi) {
      let current = { props: { parentState: this.state, liftWrapperState: this.props.liftWrapperState, liftGlobalState: this.liftGlobalState, parentProps: this.props } }
      this.setState({ directloading: true });
      let LocalVars = this.state.LocalVars;
      LocalVars.ShowHistory = false;
      this.setState({ LocalVars });

      this.setState({ sh: true });

      openRecord({ current, unique_id: identi });
      // set 
    } else {
      this.setState({ directloading: false });
    }
  }

  handleShortcuts = e => {
    // refer to these codes, https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
    let { LocalVars, pageData, currentPage, ShowSidebar, openmodals } = this.state;
    if (e.altKey && e.which == 67) { // C - create form
      let createbtn = document.getElementById("createButton");
      if (createbtn) {
        createbtn.click();
      } else {
        let scf = document.getElementById('show-create-form');
        if (scf) {
          scf.click();
        } else {
          this.setState({ notifications: { alertType: "warning", value: "Can not save form." } })
        }
      }
    }
    else if (e.altKey && e.which == 66) { // C - create form
      let scf = document.getElementById('show-search-form');
      if (scf) {
        scf.click();
      }
    }
    else if (e.which == 33) { // Page UP - paginate back
      let scf = document.getElementById('paginate-back');
      if (scf) {
        scf.click();
      }
    }
    else if (e.which == 34) { // Page DOWN - paginate forward
      let scf = document.getElementById('paginate-forward');
      if (scf) {
        scf.click();
      }
    }
    else if (e.altKey && e.which == 65) {// A - Search form
      let targetbtn = document.getElementById("action-button-search");
      if (targetbtn) {
        targetbtn.click();
        targetbtn.focus();
      } else {
        this.setState({ notifications: { alertType: "warning", value: "Can not search." } })
      }
    } else if (e.altKey && e.which == 83) { // S - SAVE form
      let elem = document.getElementById("main-form-submit-button");
      setTimeout(() => elem ? elem.click() : alert("Please fill required fields"), 10);
    }
    else if (e.ctrlKey && e.altKey && e.which == 68) { // D
      setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
    } else if (e.ctrlKey && e.altKey && e.which == 70) { // F
      setTimeout(() => document.getElementById("fastpath-textbox").focus(), 10);
    } else if (currentPage == 'ms202' && !LocalVars.showFilter) {
      if (e.altKey && e.which == 84) { // T
        setTimeout(() => document.getElementById("Deposits").click(), 10);
      }
    } else if (e.which == 13) {
      // enter should behave like a tab.
      let currentElem = document.getElementsByName("product_code");
      // if(currentElem && currentElem[0]){
      //   currentElem[0].focus();
      // }
    }
  };

  doc_keyUp = (e) => {
    this.setState({ lastTyped: new Date().getTime() });
    //code for closing filefolder.
    if (e.keyCode == 13) {
      // go to next element.
    }
    else {
      // if the cursor is not active & keyperss belongs to a shortcut.
      this.handleShortcuts(e);
    }
  }



  render() {
    let history;
    let form;
    let dashboard;

    let { formElements, currentPage } = this.state;
    if (['login', 'websearch'].indexOf(currentPage) == -1) {
      history = formElements[currentPage].history;
      form = formElements[currentPage].form;
      dashboard = formElements[currentPage].dashboard;
    }
    let { dataLoading, directloading } = this.state;

    return (
      <div className="" style={{ height: "100%" }}>
        {/* 
        <MdErrorOutline className="floating-error">
          </MdErrorOutline> */
          console.log(remoteip)
          }
        {(directloading) &&
          <div className="fullpage-loading-container">
            <div className="fullpage-loading">
              {typeof directloading == 'boolean' ? "Loading . . ." : directloading}
            </div>
          </div>
        }

        {/* <TawkMessengerReact
          propertyId="6305de7554f06e12d8906c88"
          widgetId="1gb7eq01r" /> */}


        <LogoutWarning />

        {this.props.parentState.authenticated &&
          <span>
            <ProfileMenu
              parentState={this.state}
              parentProps={this.props}
              liftGlobalState={this.liftGlobalState}
              liftState={this.liftState}
              liftWrapperState={this.props.liftGlobalState}
            />

            <TopRightMenus
              parentState={this.state}
              parentProps={this.props}
              liftGlobalState={this.liftGlobalState}
              liftState={this.liftState}
              liftWrapperState={this.props.liftGlobalState}
            />

            {history &&
              <BusinessControls
                parentState={this.state}
                parentProps={this.props}
                liftGlobalState={this.liftGlobalState}
                liftState={this.liftState}
                liftWrapperState={this.props.liftGlobalState}
              />
            }

            <GeneralControls
              parentState={this.state}
              parentProps={this.props}
              liftGlobalState={this.liftGlobalState}
              liftState={this.liftState}
              liftWrapperState={this.props.liftGlobalState}
            />

            {this.state.openControls.length > 0 &&
              <ControlSearch
                parentState={this.state}
                parentProps={this.props}
                liftGlobalState={this.liftGlobalState}
                liftState={this.liftState}
                liftWrapperState={this.props.liftGlobalState}
              />
            }

            {/* {this.state.chartBoxOpen &&
              <ChartControls
                parentState={this.state}
                parentProps={this.props}
                liftGlobalState={this.liftGlobalState}
                liftState={this.liftState}
                liftWrapperState={this.props.liftGlobalState}
              />
            } */}


            {this.state.leftSidebarLevel >= 2 &&
              <LeftSidebarMore level={2} current={this} />
            }
            {this.state.leftSidebarLevel == 3 &&
              <LeftSidebarMore level={3} current={this} />
            }
          </span>
        }



        {/* <div className="left-sub-sidebar">
            relevant component will be rendered here depending on the navbar button clicked.
          </div>
          <div className="right-sub-sidebar">
            relevant component will be rendered here depending on the navbar button clicked.
          </div>
          <div className="pagespecific-menu">
            relevant component will be rendered here depending on the navbar button clicked.
          </div> */}


        {!this.props.parentState.authenticated && this.state.currentPage == 'login' &&
          (<Login
            parentState={this.state}
            parentProps={this.props}
            liftGlobalState={this.liftGlobalState}
            liftState={this.liftState}
            liftWrapperState={this.props.liftGlobalState}
          />)
        }

        {!this.props.parentState.authenticated && this.state.currentPage == 'websearch' &&
          (<WebSearch
            parentState={this.state}
            parentProps={this.props}
            liftGlobalState={this.liftGlobalState}
            liftState={this.liftState}
            liftWrapperState={this.props.liftGlobalState}
          />)
        }

        {!this.props.parentState.authenticated && this.state.currentPage == 'Register' &&
          (<Register
            parentState={this.state}
            parentProps={this.props}
            liftGlobalState={this.liftGlobalState}
            liftState={this.liftState}
          />)}

        {this.props.parentState.authenticated && this.props.parentState.token !== "" && this.state.fileFolder.isOpen && (
          <FileFolder
            parentState={this.state}
            liftGlobalState={this.liftGlobalState}
            liftState={this.liftState}
            liftWrapperState={this.props.liftGlobalState}
            parentProps={this.props}
          />
        )}

        {['login', 'websearch'].indexOf(this.state.currentPage) == -1 && this.props.parentState.authenticated && this.props.parentState.token !== "" && !this.state.fileFolder.isOpen &&
          <div className="" style={{ height: "100%" }}>

            {!this.state.full_report && !this.props.parentState.identi &&
              <NavbarArea
                parentState={this.state}
                liftGlobalState={this.liftGlobalState}
                liftWrapperState={this.props.liftGlobalState}
                parentProps={this.props}
                liftState={this.liftState}
              />
            }

            <LeftSidebar
              display="d-none d-sm-block"
              parentState={this.state}
              parentProps={this.props}
              liftGlobalState={this.liftGlobalState}
              liftWrapperState={this.props.liftGlobalState}
            />
            <ContentArea
              liftGlobalState={this.liftGlobalState}
              parentState={this.state}>
              <div className={`row content-main`}>

                {/* {dashboard.length !=0  && (
                  <DashboardArea
                    liftState={this.liftState}
                    liftGlobalState={this.liftGlobalState}
                    parentState={this.state}
                    parentProps={this.props}
                  />
                )} */}

                {!this.state.LocalVars.showFilter && !this.state.full_report &&
                  <FormArea
                    liftState={this.liftState}
                    liftGlobalState={this.liftGlobalState}
                    liftWrapperState={this.props.liftGlobalState}
                    parentState={this.state}
                    parentProps={this.props}
                  />
                }

                {db && db[this.state.currentPage] && db[this.state.currentPage].filter &&
                  this.state.LocalVars.showFilter && !this.state.full_report &&
                  <FilterArea
                    liftState={this.liftState}
                    liftGlobalState={this.liftGlobalState}
                    parentState={this.state}
                    parentProps={this.props}
                  />
                }

                {history && this.state.LocalVars.ShowHistory && !dashboard && (
                  <ReportArea
                    // later change it to HistoryArea & change history pagetype to saveonly to avoid confusion
                    parentState={this.state}
                    liftState={this.liftState}
                    liftGlobalState={this.liftGlobalState}
                    liftWrapperState={this.props.liftGlobalState}
                    parentProps={this.props}
                  />
                )}
              </div>
            </ContentArea>

            {db && db[this.state.currentPage] &&
              <RightSidebar
                display="d-none d-sm-block"
                parentState={this.state}
                parentProps={this.props}
                liftGlobalState={this.liftGlobalState}
                liftWrapperState={this.props.liftGlobalState}
              />
            }

            {/* <div style={{width:"100%",margin:"auto"}}> */}
            {/* <div className="home-footer">© Decision Machines Private Limited 2013-2020. All rights reserved</div> */}
            {/* <div className="home-footer">© Reportkart 2020. All rights reserved</div> */}
          </div>
          // </div>
        }
      </div>
    );
  }
}

export default App;
